export default "__VITE_ASSET__43723acc__"